import type React from "react";
import { useState } from "react";

import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { faLightbulbOn } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { useTheme } from "styled-components";

import { Body, BodySmallBold } from "./styles";

interface Props {
  tip_description: string;
  tip_title: string;
}

export const TipCard: React.FC<Props> = ({ tip_description, tip_title }) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Container onClick={() => setIsExpanded(prevState => !prevState)}>
      <TipHeading>
        <TipTitleContainer>
          <FontAwesomeIcon
            icon={faLightbulbOn}
            fontSize="16px"
            color={theme.colors.redesign.o100}
            style={{ marginRight: "8px" }}
          />
          <BodySmallBold>{tip_title}</BodySmallBold>
        </TipTitleContainer>
        <TipArrow>
          <FontAwesomeIcon
            icon={isExpanded ? faChevronUp : faChevronDown}
            fontSize="16px"
            color={theme.colors.redesign.db90}
          />
        </TipArrow>
      </TipHeading>
      {isExpanded && tip_description && <StyledBody>{tip_description}</StyledBody>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding: 12px 16px;
  background-color: #fffdfc;
  border-radius: 8px;
`;

const TipHeading = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TipTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TipArrow = styled.div`
  display: flex;
`;

const StyledBody = styled(Body)`
  margin: 8px 4px 4px;
  color: ${({ theme }) => theme.colors.redesign.db70};
  white-space: pre-wrap;
`;
